import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { auth401Interceptor } from './core/interceptors/auth-401.interceptor';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { routes } from './app-routing.module';
import { environment } from '../environments/environment';
import { provideFirebaseApp, initializeApp, getApps } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';

// Firebase providers
const firebaseProviders = [
  provideFirebaseApp(() => {
    try {
      const existingApps = getApps();
      if (existingApps.length > 0) {
        return existingApps[0];
      }
      const firebaseConfig = environment.firebaseConfig;
      return initializeApp(firebaseConfig);
    } catch (error) {
      console.error('Firebase initialization failed:', error);
      throw error;
    }
  }),
  provideAuth(() => {
    try {
      return getAuth();
    } catch (error) {
      console.error('Firebase Auth initialization failed:', error);
      throw error;
    }
  }),
  provideMessaging(() => {
    try {
      return getMessaging();
    } catch (error) {
      console.error('Firebase Messaging initialization failed:', error);
      throw error;
    }
  })
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([auth401Interceptor])),
    provideAnimations(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      })
    ),
    provideIonicAngular(),
    ...firebaseProviders,
    importProvidersFrom(
      FormsModule,
      ToastrModule.forRoot({
        timeOut: 3000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
        progressBar: true
      })
    )
  ]
};



